(() => {
  if (window.BPValueLadderReady) return;
  window.BPValueLadderReady = true;

  const selectedByLadder = new Map();
  const ladderSelector = '[data-bp-value-ladder]';

  const choose = (ladder, variantId, announce = false) => {
    const panels = Array.from(ladder.querySelectorAll('[data-bp-value-panel]'));
    const selected = panels.find((panel) => panel.dataset.variantId === variantId);
    if (!selected) return;

    panels.forEach((panel) => {
      panel.hidden = panel !== selected;
    });
    ladder.querySelectorAll('[data-bp-value-choice]').forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.bpValueChoice === variantId));
    });
    ladder.dataset.selectedVariant = variantId;
    selectedByLadder.set(ladder.dataset.ladderKey, variantId);
    ladder.dataset.bpValueReady = 'true';
    if (announce) {
      const live = ladder.querySelector('[data-bp-value-live]');
      if (live) live.textContent = `${selected.getAttribute('aria-label') || ''}. ${selected.innerText.replace(/\s+/g, ' ').trim()}`;
    }
  };

  const initialize = (scope) => {
    if (!(scope instanceof Element || scope instanceof Document)) return;
    const ladders = scope.matches?.(ladderSelector) ? [scope] : scope.querySelectorAll(ladderSelector);
    ladders.forEach((ladder) => {
      const saved = selectedByLadder.get(ladder.dataset.ladderKey);
      const desired = saved || ladder.dataset.selectedVariant || ladder.dataset.defaultVariant;
      const valid = Array.from(ladder.querySelectorAll('[data-bp-value-panel]')).some((panel) => panel.dataset.variantId === desired);
      choose(ladder, valid ? desired : ladder.dataset.defaultVariant);
    });
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('[data-bp-value-choice]');
    const ladder = button?.closest(ladderSelector);
    if (ladder) choose(ladder, button.dataset.bpValueChoice, true);
  });

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const scope = event.target;
    const ladders = scope?.matches?.(ladderSelector) ? [scope] : scope?.querySelectorAll?.(ladderSelector) || [];
    ladders.forEach((ladder) => {
      if (ladder.dataset.selectedVariant) selectedByLadder.set(ladder.dataset.ladderKey, ladder.dataset.selectedVariant);
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  } else {
    initialize(document);
  }
})();
